module.exports = {"input":80,"textarea":650}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json-resources/text-field-configs.json
// module id = pqj4
// module chunks = 0